<!--
 * @Description: Jeson Create File
 * @Version: 1.0
 * @Autor: Jeson
 * @Date: 2022-01-08 15:56:53
 * @LastEditors: Jeson
 * @LastEditTime: 2022-03-07 10:01:08
-->
<template>
  <div class="bgf5">
    <iHeader />
    <iNav />
    <iClassify ref="iClassify" :active="activeIndex" all-active />
    <iRightFixedBox />
    <iHomeAdCarousel v-if="true" ref="iHomeAdCarousel" />
    <div style="min-height: 600px;">
      <div id="FactoryList">
        <div class="factory-div">
          <div v-if="type==3" class="factory-div-content">
            <div
              v-for="(item, index) in goods"
              :key="index"
              class="factory-div-content-good"
            >
              <NewProductItem :product="item" />
            </div>
          </div>
          <el-tabs v-else v-model="activeName" type="border-card" style="width: 103%;" @tab-click="tabClick">
            <el-tab-pane v-for="(i,k) in classifyList" :key="i.Id" :name="`${k}`" :label="i.ClassifyName">
              <div class="factory-div-content">
                <div
                  v-for="(item, index) in goods"
                  :key="index"
                  class="factory-div-content-good"
                >
                  <NewProductItem :product="item" />
                </div>
              </div>

            </el-tab-pane>

          </el-tabs>

        </div>
      </div>
    </div>
    <iFooter />
    <add-new-goods-collect-tips ref="addNewCollectTipsRef" />
  </div>
</template>

<script>
import iHeader from '@/components/Header'
import iNav from '@/components/Nav'
import iClassify from '@/components/Classify'
import iFooter from '@/components/Footer'
import { BaseMixin } from '@/mixins/BaseMixin'
import iHomeAdCarousel from '@/views/home/HomeAdCarousel.vue'
import AddNewGoodsCollectTips from '@/components/AddNewGoodsCollectTips.vue'
import iRightFixedBox from '@/components/RightFixedBox'

export default {
  name: 'HotSaleList',
  components: {
    iHeader,
    iNav,
    iClassify,
    iFooter,
    AddNewGoodsCollectTips,
    iHomeAdCarousel,
    iRightFixedBox
  },
  mixins: [BaseMixin],
  data() {
    return {
      activeIndex: 1,
      goods: [],
      Id: '',
      Offset: 0,
      IsHasNext: false,
      loading: false,
      Logo: '',
      BrandName: '',
      timer: null,
      classifyList: [],
      ClassIds: '',
      type: '',
      activeName: 0
    }
  },
  watch: {},
  destroyed() {},
  created() {
    this.type = this.$route.query.type
    if (this.type != 3) {
      this.getClassify()
    } else {
      this.getList()
    }
    this.getHomePageShowData()
  },
  beforeDestroy() {},
  mounted() {
    // 绑定监听页面滑动方法
    window.addEventListener('scroll', this.handleSearch)
  },
  methods: {
    // 诊所/药店获取分类
    async getClassify() {
      this.$hys.openLoading()
      const data = await this.getAction(
        '/api_goods/OperatingClassify/GetListOwner',
        {
          isOnlyGoodsControl: false
        }
      )
      if (data.IsSuccess) {
        this.classifyList = data.Data
        this.getList()
      }
    },
    // 获取首页展示数据 轮播图 广告图 分类导航
    async getHomePageShowData() {
      const res = await this.getAction(
        '/api_basedata/HomePage/GetAdvertisingPageV2',
        {
          codes:
            this.type == 5 ? 'ydrx001' : this.type == 4 ? 'zsrx001' : 'jjrx001'
        }
      )
      if (res.IsSuccess) {
        if (this.$refs['iHomeAdCarousel']) {
          this.$refs['iHomeAdCarousel'].init(res.Data)
        }
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    tabClick() {
      this.Offset = 0
      this.IsHasNext = false
      this.goods = []
      this.getList()
    },
    async getList() {
      this.loading = true
      const res = await this.getAction(
        '/api_goods/GoodsSku/ListForCustomerV3',
        {
          Offset: this.Offset,
          ClassIds: this.type != 3 ? this.classifyList[this.activeName].Id : '',
          SortType: this.type,
          IsSortAsc: false
        }
      )
      if (res.IsSuccess) {
        res.Data.GoodsList.map((oo) => {
          this.goods.push(oo)
        })
        this.IsHasNext = res.Data.IsHasNext
        this.Offset = res.Data.Offset
        this.loading = false
      }
      this.$hys.clearLoading()
    },
    /*
     * 监听页面滑动
     */
    handleSearch() {
      // 获取当前页面高度
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop

      // 获取网页可见区域高
      const clientHeight = document.body.clientHeight
      // 获取网页正文全文高
      const scrollHeight = document.body.scrollHeight

      // 当前页面高度大于指定位置时记录

      // 到达页面底部时
      if (scrollTop + clientHeight + 400 >= scrollHeight) {
        if (this.IsHasNext && this.loading === false) {
          this.getList()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
#FactoryList {
  margin: auto;
  width: 1200px;
  max-width: 1200px;

  .factory-div {
    margin-top: 17px;
    border-radius: 2px;
    height: 529px;
    height: 100%;
    background: #FFFFFF;

    .factory-div-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 80px;
      background: #FDD6D2;

      :nth-child(1) {
        display: flex;
        align-items: center;

        div {
          font-size: 24px;
          font-weight: 600;
          color: #111A34;
        }
      }

      :nth-child(2) {
        margin-right: 22px;
        font-size: 18px;
        font-weight: 500;
        color: #666F83;
      }

      img {
        margin-right: 15px;
        margin-left: 22px;
        width: 80px;
        height: 60px;
      }
    }

    .factory-div-content {
      display: flex;
      flex-wrap: wrap;

      .factory-div-content-good {
        padding: 8px 0;
        width: 240px;
      }
    }
  }

  .border-card {
    width: 102%;
  }
}
</style>
